import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { NotFound404Component } from './components/errors/not-found404/not-found404.component';
import { TrackingDetailsComponent } from './components/users/customers/tracking-details/tracking-details.component';
import { PrivilegiosCustomer } from './authguard/privilegiosCustomer.guard';
import { ProveedorGuard } from './authguard/proveedor.guard';
import { ConductorGuard } from './authguard/conductor.guard';
import { AdminGuard } from './authguard/admin.guard';

const routes: Routes = [
  {
    path: 'login', children: [
      { path: '', component: LoginComponent },
      { path: 'conductor', component: LoginComponent }
    ]
  },
  { path: 'customer/tracking/:codigoTracking', component: TrackingDetailsComponent },
  { path: '', component: LoginComponent },
  { path: 'customer', canActivate: [PrivilegiosCustomer], loadChildren: () => import('./components/users/customers/customer.module').then(m => m.CustomersModule) },
  { path: 'proveedor', canActivate: [ProveedorGuard], loadChildren: () => import('./components/users/proveedor/proveedor.module').then(m => m.ProveedorModule) },
  { path: 'conductor', canActivate: [ConductorGuard], loadChildren: () => import('./components/users/conductor/conductor.module').then(m => m.ConductorModule) },
  { path: 'admin', canActivate: [AdminGuard], loadChildren: () => import('./components/users/admin/admin.module').then(m => m.AdminModule) },
  { path: '**', component: NotFound404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
